import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import './emails.css';
import { findBlock, labelFor } from '../../../utils/emailBlockDoc';
import BlockInspector from './BlockInspector';

// The properties of whatever is selected, floating over the email itself.
//
// It is here, over the canvas, and not in a third column, because the whole
// complaint about the two rejected layouts was looking in one place and editing
// in another. Everything a block's properties change is a few centimetres away
// and visibly changes when you change it.
//
// Content is BlockInspector, unchanged: FIELDS / SETTINGS_FIELDS in
// src/utils/emailBlockDoc.js are asserted against the serialiser's BLOCK_DEFAULTS
// key for key, in both directions, so this panel cannot set a prop nothing
// renders nor drop one the serialiser reads.
//
// It COLLAPSES, and that is not decoration. Left open it covers the top right of
// the email, which is where the header image is in most of these templates. It
// opens itself when a block is selected — the click that selects is a request to
// edit — and can be shut without deselecting.
const BlockPropertiesPanel = ({
  doc, selectedId, onChangeBlock, onChangeSettings, onSelect,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const block = findBlock(doc, selectedId);

  // Selecting a block opens the panel. Deselecting leaves it as it is: closing
  // it for the user after every delete would be one surprise too many.
  useEffect(() => {
    if (selectedId) setIsOpen(true);
  }, [selectedId]);

  const heading = block ? `${labelFor(block.type)} properties` : 'Email settings';

  return (
    <div className={isOpen ? 'blockprops is-open' : 'blockprops'}>
      <div className="blockprops-head">
        <h4>{heading}</h4>
        <button
          type="button"
          className="tbtn"
          onClick={() => setIsOpen(previous => !previous)}
          title={isOpen ? 'Get this out of the way of the email' : 'Show the properties of the selected block'}
        >
          {isOpen ? 'Hide' : 'Show'}
        </button>
      </div>

      {isOpen && (
        <div className="blockprops-body">
          <BlockInspector
            doc={doc}
            selectedId={selectedId}
            onChangeBlock={onChangeBlock}
            onChangeSettings={onChangeSettings}
            onSelect={onSelect}
          />
        </div>
      )}
    </div>
  );
};

BlockPropertiesPanel.propTypes = {
  doc: PropTypes.shape({
    settings: PropTypes.shape({}).isRequired,
    blocks: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  }).isRequired,
  selectedId: PropTypes.string,
  onChangeBlock: PropTypes.func.isRequired,
  onChangeSettings: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
};

BlockPropertiesPanel.defaultProps = {
  selectedId: null,
};

export default BlockPropertiesPanel;
